import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function DevicesModule() {
  return <ModuleNavigation moduleId="DevicesModule" />;
}
